// extracted by mini-css-extract-plugin
module.exports = {"amendReport":"AmendReport_amendReport__a4psw"};